import { UnitType } from '@exodus/currency'

const name = 'vertcoin'
const displayName = 'Vertcoin'
const ticker = 'VTC'
const displayTicker = ticker
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#EAEAEA'
const gradientColors = ['#EAEAEA', '#FFF']
const gradientCoords = { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' }
const chainBadgeColors = gradientColors

const units = {
  satoshis: 0,
  VTC: 8,
}
const currency = UnitType.create(units)

const assetType = 'BITCOIN_LIKE'
const blockExplorer = {
  addressUrl: (address) => `https://insight.vertcoin.org/address/${address}`,
  txUrl: (txId) => `https://insight.vertcoin.org/tx/${txId}`,
}
const info = {
  description:
    'Vertcoin is a cryptocurrency similar to Bitcoin with additional features like specialized computer (ASIC) resistance for fair and affordable mining.',
  reddit: 'https://www.reddit.com/r/vertcoin/',
  twitter: 'https://twitter.com/Vertcoin',
  website: 'https://vertcoin.org/',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
